/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import IndexedDB from "@/helpers/IndexedDB.js";

export default {
	getRouting() {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		return IndexedDB.getKey("routing", userInfo.uid);
	},
	async saveRouting({commit, state, dispatch}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const type = await dispatch("getRouting");
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					if (type) {
						const updateRouting = {...type, type: payload};
						commit("UPDATE_ROUTING_TYPE", updateRouting);
						await IndexedDB.update("routing", updateRouting, userInfo.uid);
						resolve(type);
					} else {
						await IndexedDB.save("routing", {...state, type: payload}, userInfo.uid);
						commit("UPDATE_ROUTING_TYPE", state);
						resolve(state);
					}
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
	async saveAvailableRouters({commit, state, dispatch}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const type = await dispatch("getRouting");
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					if (type) {
						const updateAvailableRouters = {...type, availableRouters: payload};
						commit("UPDATE_AVAILABLE_ROUTERS", updateAvailableRouters);
						await IndexedDB.update("routing", updateAvailableRouters, userInfo.uid);
						resolve(type);
					} else {
						await IndexedDB.save("routing", {...state, availableRouters: payload}, userInfo.uid);
						commit("UPDATE_AVAILABLE_ROUTERS", state);
						resolve(state);
					}
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
	async saveTypeVehicle({commit, state, dispatch}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const type = await dispatch("getRouting");
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					if (type) {
						const updateTypeVehicle = {...type, typeVehicle: payload};
						commit("UPDATE_TYPE_VEHICLE", updateTypeVehicle);
						await IndexedDB.update("routing", updateTypeVehicle, userInfo.uid);
						resolve(type);
					} else {
						await IndexedDB.save("routing", {...state, typeVehicle: payload}, userInfo.uid);
						commit("UPDATE_TYPE_VEHICLE", state);
						resolve(state);
					}
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
};
